import { FILE_ATTACHED_ITEMS_PAGE_COUNT } from './FileAttachedItemsModal.constants'

export function getAttachedItemsApiParams({ objectId }) {
  return objectId
}

export function parseAttachedItemPaginationData(data) {
  return {
    count: data.count,
    pageCount: data.pages,
    pageSize: FILE_ATTACHED_ITEMS_PAGE_COUNT,
  }
}

export function isEqualFileAttachedItemsModal({ isDeletingState, readonly }) {
  return !readonly && !isDeletingState
}
